import { render, staticRenderFns } from "./WhyBanner.vue?vue&type=template&id=3fdd15de&scoped=true"
import script from "./WhyBanner.vue?vue&type=script&lang=js"
export * from "./WhyBanner.vue?vue&type=script&lang=js"
import style0 from "./WhyBanner.vue?vue&type=style&index=0&id=3fdd15de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdd15de",
  null
  
)

export default component.exports